import styled from "styled-components";
import { useState, useEffect } from "react";

const media ={
    desktop: '@media (min-width: 800px)',
    mobile: '@media (max-width: 780px)',
    phone: '@media (max-width: 580px)'
    }

function NavStuff() {
    var [date, setDate] = useState(new Date()) ;

    useEffect (() => {
    var timer = setInterval(() => setDate(new Date()), 1000)

    return function cleanup() {
    clearInterval(timer)
        }}); 

    return(
    <NavStyle>
        <h2 className="un date">{date.toLocaleDateString()}</h2>
        <a href="/">
            <h1>
                <span className="un">U</span>
                <span className="ii">NI</span>
                <span className="star">STAR</span>
            </h1>
        </a>  
        <h2 className="un date">{date.toLocaleTimeString()}</h2>
    </NavStyle>
      )
}

export default NavStuff

const NavStyle = styled.nav`
width:100% ;
height: 10vh;
display: flex ;
justify-content: space-evenly ;
align-items: center;

a{
    text-decoration: none;
}


${media.phone}{
    .date{
        display: none;
    }
}
`